import { request } from '@/utils/api';

export interface DuckStatus { enabled: boolean; ai?: boolean; aiDemo?: boolean; openReports?: number }
export interface GuideStep { target: string; say: string }
export interface AskResult { answer: string; steps: GuideStep[]; demo: boolean; reported: boolean }
export interface MyReport { reportId: number; message: string; status: string; replyToUser?: string | null; replyNew: boolean; createdAt: string }
export interface ReportInput {
    message: string; route: string; elementLabel?: string; elementSelector?: string; elementText?: string;
    viewport: string; userAgent: string; source?: 'EENDJIE' | 'EENDJIE_FOUT';
}

export const duckStatus = (): Promise<DuckStatus> => request('GET', '/duck/status');
export const sendReport = (input: ReportInput) => request('POST', '/duck/reports', input);
export const myReports = (): Promise<MyReport[]> => request('GET', '/duck/reports/mine');
export const markSeen = (id: number) => request('POST', `/duck/reports/${id}/seen`, {});
export const setEnabledForBrokerage = (enabled: boolean) => request('PUT', '/duck/settings', { enabled });
export const ask = (question: string, route: string): Promise<AskResult> => request('POST', '/duck/ask', { question, route });
